import React from "react";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { useDispatch, useSelector } from "react-redux";
// import { toggleTheme } from "./themeSlice";

const AppThemeProvider = (props) => {
  const { mode } = useSelector((state) => state.theme);

  const theme = createTheme({
    palette: {
      mode,
    },
  });

  return (
    <>
      <ThemeProvider theme={theme}>{props.children}</ThemeProvider>
    </>
  );
};

export default AppThemeProvider;
